// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.summary-wapper {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  max-width: 100%;
}
.summary-wapper__title {
  width: 95%;
  padding-left: 20px;
  color: #1D283C;
  margin-top: 10px;
  margin-bottom: 10px;
}
.summary-wapper__down {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 30px;
}
.summary-wapper__down.info {
  padding-left: 20px;
  padding-right: 20px;
}
.summary-wapper__detail {
  text-align: center;
  padding: 15px;
  min-width: 100px;
}
.summary-wapper__detail--text1 {
  color: white;
}
.summary-wapper__detail--text2 {
  font-weight: 600;
  color: white;
}
.summary-wapper .page-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.summary-wapper .page-title .unsupported-version {
  color: #ff4d4f;
  font-size: 16px;
  font-weight: bold;
}
.summary-wapper .button-summary-wrappper {
  color: #1D283C;
  background-color: #d9d9d9;
  padding: 5px 30px;
  border: none;
  font-weight: 600;
}
.summary-wapper .button-summary-wrappper2 {
  color: white;
  background-color: #a6a6a6;
  padding: 5px 30px;
  border: none;
  font-weight: 600;
}

.disk-usage {
  font-family: "Pretendard", "Roboto", "Helvetica", "Arial", sans-serif;
  color: white;
  background-color: gray;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  margin: auto;
}

.header,
.disk-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.header span {
  flex: 1 1;
  font-weight: bold;
}

.disk-row span {
  flex: 1 1;
}

.usage-bar-container {
  flex: 2 1;
  display: flex;
  align-items: center;
}

.usage-bar {
  height: 20px;
  background: linear-gradient(to right, #00f, #0ff, #0f0, #ff0, #f00);
  border-radius: 5px;
  margin-right: 10px;
}

.usage-bar-container span {
  white-space: nowrap;
}

/* Tooltip 스타일 오버라이드 */
.ant-tooltip-inner {
  background-color: red !important;
  color: white;
}

.summary-header {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 10px;
  margin: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  overflow-x: auto;
  min-width: 640px;
}
@media (max-width: 768px) {
  .summary-header {
    max-width: 100%;
    margin: 10px;
  }
}
.summary-header .info-section {
  display: flex;
  gap: 48px;
  flex-shrink: 0;
}
.summary-header .info-section .info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.summary-header .info-section .info-item .info-label {
  font-size: 16px;
  color: #011dbe;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  padding-left: 20px;
}
.summary-header .info-section .info-item .info-value {
  font-size: 16px;
  color: #2b3674;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
  padding-left: 20px;
}
.summary-header .action-buttons {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-shrink: 0;
}
.summary-header .action-buttons .action-button {
  background: transparent;
  border: none;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.summary-header .action-buttons .action-button:hover {
  background: rgba(45, 172, 236, 0.1);
}
.summary-header .action-buttons .action-button img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

div.action-tooltip .ant-tooltip-inner {
  background-color: #2b3674 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  padding: 8px 12px !important;
  border-radius: 4px !important;
}
div.action-tooltip .ant-tooltip-arrow::before {
  background-color: #2b3674 !important;
}

.summary-wapper.popup-mode {
  margin: 0;
  padding: 20px;
  min-height: 100vh;
  background: #fff;
  margin-left: 0 !important;
}
.summary-wapper.popup-mode .page-title {
  margin-top: 0;
}

body.popup-window {
  margin: 0;
  padding: 0;
  overflow: auto;
}

body.iframe-view {
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #fff !important;
}

.summary-wapper.iframe-mode {
  margin: 0;
  padding: 0;
  background-color: #fff !important;
  margin-left: 0 !important;
}
.summary-wapper.iframe-mode .page-title {
  display: none;
}
.summary-wapper.iframe-mode .summary-header {
  background-color: #fff;
}
.summary-wapper.iframe-mode .summary-wapper__down {
  margin: 10px 0;
  background-color: #fff;
}

.summary-wapper.standalone-mode {
  margin-left: 0 !important;
  padding: 20px;
  min-height: 100vh;
  background: #fff;
}

.section-top-button {
  display: block;
  margin: 20px auto 0;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}
.section-top-button:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.scroll-to-top-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 999;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}
.scroll-to-top-button:hover {
  background-color: rgba(0, 0, 0, 0.9);
  transform: translateY(-5px);
}

.section-navigation {
  position: sticky;
  top: 20px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 20px;
  z-index: 100;
}
.section-navigation ul {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  overflow-x: auto;
}
.section-navigation ul li {
  margin-right: 15px;
  white-space: nowrap;
}
.section-navigation ul li a {
  color: white;
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.3s;
}
.section-navigation ul li a:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

@media (max-width: 576px) {
  .summary-header {
    gap: 10px;
  }
  .summary-header .info-section {
    gap: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Summary/SummaryStyled.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,sBAAA;EA0DA,gBAAA;EACA,eAAA;AAvDF;AAHE;EACE,UAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAKJ;AAHE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;AAKJ;AAJI;EACE,kBAAA;EACA,mBAAA;AAMN;AAHE;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;AAKJ;AAJI;EACE,YAAA;AAMN;AAJI;EACE,gBAAA;EACA,YAAA;AAMN;AAFE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAIJ;AAFI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAIN;AAAE;EACE,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAEJ;AAAE;EACE,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAEJ;;AAKA;EACE,qEAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;AAFF;;AAKA;;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAFF;;AAKA;EACE,SAAA;EACA,iBAAA;AAFF;;AAKA;EACE,SAAA;AAFF;;AAKA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;AAFF;;AAKA;EACE,YAAA;EACA,mEAAA;EACA,kBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA,sBAAA;AACA;EACE,gCAAA;EACA,YAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;AAIE;EAbF;IAcI,eAAA;IACA,YAAA;EADF;AACF;AAGE;EACE,aAAA;EACA,SAAA;EACA,cAAA;AADJ;AAGI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADN;AAGM;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AADR;AAIM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAFR;AAOE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;AALJ;AAOI;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AALN;AAOM;EACE,mCAAA;AALR;AAQM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AANR;;AAcE;EACE,oCAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;AAXJ;AAcE;EACE,oCAAA;AAZJ;;AAiBA;EACE,SAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EAOA,yBAAA;AApBF;AAeE;EACE,aAAA;AAbJ;;AAqBA;EACE,SAAA;EACA,UAAA;EACA,cAAA;AAlBF;;AAsBA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,iCAAA;AAnBF;;AAsBA;EACE,SAAA;EACA,UAAA;EACA,iCAAA;EAmBA,yBAAA;AArCF;AAoBE;EACE,aAAA;AAlBJ;AAqBE;EAGE,sBAAA;AArBJ;AAyBE;EACE,cAAA;EACA,sBAAA;AAvBJ;;AA+BA;EACE,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AA5BF;;AAgCA;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AA7BF;AA+BE;EACE,oCAAA;AA7BJ;;AAkCA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,yCAAA;EACA,yBAAA;AA/BF;AAiCE;EACE,oCAAA;EACA,2BAAA;AA/BJ;;AAoCA;EACE,gBAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAjCF;AAmCE;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAjCJ;AAmCI;EACE,kBAAA;EACA,mBAAA;AAjCN;AAmCM;EACE,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;AAjCR;AAmCQ;EACE,0CAAA;AAjCV;;AAwCA;EACE;IACE,SAAA;EArCF;EAuCE;IACE,SAAA;EArCJ;AACF","sourcesContent":[".summary-wapper {\n  display: flex;\n  flex-direction: column;\n  &__title {\n    width: 95%;\n    padding-left: 20px;\n    color: #1D283C;\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n  &__down {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    padding-bottom: 30px;\n    &.info {\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n  }\n  &__detail {\n    text-align: center;\n    padding: 15px;\n    min-width: 100px;\n    &--text1 {\n      color: white;\n    }\n    &--text2 {\n      font-weight: 600;\n      color: white;\n    }\n  }\n\n  .page-title {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    \n    .unsupported-version {\n      color: #ff4d4f;\n      font-size: 16px;\n      font-weight: bold;\n    }\n  }\n\n  .button-summary-wrappper {\n    color: #1D283C;\n    background-color: #d9d9d9;\n    padding: 5px 30px;\n    border: none;\n    font-weight: 600;\n  }\n  .button-summary-wrappper2 {\n    color: white;\n    background-color: #a6a6a6;\n    padding: 5px 30px;\n    border: none;\n    font-weight: 600;\n  }\n\n  overflow-x: auto;\n  max-width: 100%;\n}\n\n.disk-usage {\n  font-family: \"Pretendard\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  color: white;\n  background-color: gray;\n  padding: 20px;\n  border-radius: 5px;\n  width: 80%;\n  margin: auto;\n}\n\n.header,\n.disk-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n}\n\n.header span {\n  flex: 1;\n  font-weight: bold;\n}\n\n.disk-row span {\n  flex: 1;\n}\n\n.usage-bar-container {\n  flex: 2;\n  display: flex;\n  align-items: center;\n}\n\n.usage-bar {\n  height: 20px;\n  background: linear-gradient(to right, #00f, #0ff, #0f0, #ff0, #f00);\n  border-radius: 5px;\n  margin-right: 10px;\n}\n\n.usage-bar-container span {\n  white-space: nowrap;\n}\n\n/* Tooltip 스타일 오버라이드 */\n.ant-tooltip-inner {\n  background-color: red !important;\n  color: white;\n}\n\n.summary-header {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  padding: 10px;\n  margin: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 4px;\n  overflow-x: auto;\n  min-width: 640px;\n\n  @media (max-width: 768px) {\n    max-width: 100%;\n    margin: 10px;\n  }\n\n  .info-section {\n    display: flex;\n    gap: 48px;\n    flex-shrink: 0;\n\n    .info-item {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n\n      .info-label {\n        font-size: 16px;\n        color: #011dbe;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        font-weight: 600;\n        padding-left: 20px;\n      }\n\n      .info-value {\n        font-size: 16px;\n        color: #2b3674;\n        font-weight: 600;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 250px;\n        padding-left: 20px;\n      }\n    }\n  }\n\n  .action-buttons {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    flex-shrink: 0;\n\n    .action-button {\n      background: transparent;\n      border: none;\n      padding: 12px;\n      border-radius: 8px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: rgba(45, 172, 236, 0.1);\n      }\n\n      img {\n        width: 50px;\n        height: 50px;\n        object-fit: contain;\n      }\n    }\n  }\n}\n\n// 툴팁 커스텀 스타일\ndiv.action-tooltip {\n  .ant-tooltip-inner {\n    background-color: #2b3674 !important;\n    color: #ffffff !important;\n    font-size: 14px !important;\n    padding: 8px 12px !important;\n    border-radius: 4px !important;\n  }\n\n  .ant-tooltip-arrow::before {\n    background-color: #2b3674 !important;\n  }\n}\n\n// 팝업 모드일 때 스타일 추가\n.summary-wapper.popup-mode {\n  margin: 0;\n  padding: 20px;\n  min-height: 100vh;\n  background: #fff;\n  \n  .page-title {\n    margin-top: 0;\n  }\n  \n  // 사이드바 여백 제거\n  margin-left: 0 !important;\n}\n\n// 팝업 창일 때 body 스타일 수정\nbody.popup-window {\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n}\n\n// iframe 모드 스타일 개선\nbody.iframe-view {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background-color: #fff !important;\n}\n\n.summary-wapper.iframe-mode {\n  margin: 0;\n  padding: 0;\n  background-color: #fff !important;\n  \n  .page-title {\n    display: none; // 제목 숨김\n  }\n  \n  .summary-header {\n    // margin: 0 0 20px 0;\n    // border-radius: 0;\n    background-color: #fff;\n  }\n  \n  // 여백 조정\n  .summary-wapper__down {\n    margin: 10px 0;\n    background-color: #fff;\n  }\n  \n  // 사이드바 여백 제거\n  margin-left: 0 !important;\n}\n\n// 독립 실행 모드 스타일 추가\n.summary-wapper.standalone-mode {\n  margin-left: 0 !important;\n  padding: 20px;\n  min-height: 100vh;\n  background: #fff;\n}\n\n// 섹션별 상단 이동 버튼\n.section-top-button {\n  display: block;\n  margin: 20px auto 0;\n  padding: 8px 16px;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n  \n  &:hover {\n    background-color: rgba(0, 0, 0, 0.8);\n  }\n}\n\n// 고정된 맨 위로 버튼\n.scroll-to-top-button {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  width: 50px;\n  height: 50px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 999;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  \n  &:hover {\n    background-color: rgba(0, 0, 0, 0.9);\n    transform: translateY(-5px);\n  }\n}\n\n// 섹션 내비게이션 메뉴 (선택 사항)\n.section-navigation {\n  position: sticky;\n  top: 20px;\n  background-color: rgba(0, 0, 0, 0.7);\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 20px;\n  z-index: 100;\n  \n  ul {\n    display: flex;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    overflow-x: auto;\n    \n    li {\n      margin-right: 15px;\n      white-space: nowrap;\n      \n      a {\n        color: white;\n        text-decoration: none;\n        padding: 5px 10px;\n        border-radius: 4px;\n        transition: background-color 0.3s;\n        \n        &:hover {\n          background-color: rgba(255, 255, 255, 0.2);\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .summary-header {\n    gap: 10px;\n    \n    .info-section {\n      gap: 30px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
